import React from "react";
import { COLUMN_LABELS, REQUIRED_COLUMNS } from "../../decision/importColumns.mjs";

// Показується, коли автоматичне розпізнавання колонок за заголовком не
// знайшло всі потрібні колонки -- виводить список знайдених заголовків і
// дає користувачу зіставити відсутні колонки вручну.
const ColumnMapper = ({ foundHeaders, headerEntries, indices, missing, onChange }) => {
  if (!missing || missing.length === 0) return null;
  const entries = headerEntries || (foundHeaders || []).map((text, index) => ({ index, text }));

  return (
    <div className="input-component" data-testid="column-mapper">
      <p className="text-header" style={{ color: "var(--full-busy)" }}>
        Не вдалося автоматично розпізнати колонки:{" "}
        {missing.map((key) => COLUMN_LABELS[key]).join(", ")}. Знайдені
        заголовки у файлі:
      </p>
      <p className="text-header">
        {foundHeaders && foundHeaders.length > 0 ? foundHeaders.join(" | ") : "—"}
      </p>

      <div className="form-container column-map">
        {REQUIRED_COLUMNS.map((key) => (
          <div className="input-block text-header" key={key}>
            <p className="text-header">{COLUMN_LABELS[key]}:</p>
            <select
              className="header-content-select"
              aria-label={COLUMN_LABELS[key]}
              value={indices[key] === null || indices[key] === undefined ? "" : indices[key]}
              onChange={(e) =>
                onChange(key, e.target.value === "" ? null : Number(e.target.value))
              }
            >
              <option value="">Не зіставлено</option>
              {entries.map((entry) => (
                <option key={`${entry.index}-${entry.text}`} value={entry.index}>
                  {entry.text}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColumnMapper;
